import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
export function Navbar() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed top-0 left-0 right-0 z-50 glass-panel border-b border-white/10" data-id="element-172">
      <div className="container mx-auto px-6 h-20 flex items-center justify-between" data-id="element-173">
        <div className="flex items-center gap-3" data-id="element-174">
          <div className="w-10 h-10 rounded-lg metallic-gradient flex items-center justify-center shadow-[0_0_15px_rgba(192,192,192,0.3)]" data-id="element-175">
            <div className="w-6 h-6 bg-[#0D1117] rounded-sm flex items-center justify-center" data-id="element-176">
              <span className="text-[#C0C0C0] font-bold font-heading text-lg" data-id="element-177">
                A
              </span>
            </div>
          </div>
          <span className="font-heading font-bold text-lg tracking-tight hidden sm:block" data-id="element-178">
            ALUM<span className="text-[#2F80ED]" data-id="element-179">PRO</span>
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-300" data-id="element-180">
          <a href="#niveles" className="hover:text-white transition-colors" data-id="element-181">
            Niveles
          </a>
          <a href="#bonus" className="hover:text-white transition-colors" data-id="element-182">
            Bonus
          </a>
          <a href="#testimonios" className="hover:text-white transition-colors" data-id="element-183">
            Testimonios
          </a>
          <a href="#faq" className="hover:text-white transition-colors" data-id="element-184">
            FAQ
          </a>
        </div>

        <a href="https://checkout.librofy.online/cart/53265711235435:1" target="_blank" rel="noopener noreferrer" className="bg-[#2F80ED] hover:bg-[#2563EB] text-white px-5 py-2.5 rounded-full font-semibold text-sm transition-all flex items-center gap-2 blue-glow hover:scale-105" data-id="element-185">
          <Download className="w-4 h-4" data-id="element-186" />
          <span className="hidden sm:inline" data-id="element-187">Acceder Ahora</span>
        </a>
      </div>
    </motion.nav>;
}